import React, { useEffect, useState, useRef, useCallback } from 'react';
import { ReloadOutlined, BgColorsOutlined, UnorderedListOutlined, OrderedListOutlined, BoldOutlined, SplitCellsOutlined, LoadingOutlined } from '@ant-design/icons';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useSelector, useDispatch } from 'react-redux';
import { Input, Switch, Radio, Button, Tooltip, Spin } from 'antd';
import DraggableImage from './DraggableImage';
import { changeFaintBackgroundImageUrl, changeShowFaintBackgroundImages } from '../Store/allreducer';
import { createPattern } from '../Common/static';
const { TextArea } = Input;


const PrevArrow = (props) => {
  const { onClick, isMobile } = props;
  console.log('prevArrow', props, isMobile);
  
  return (
    <button 
      className='slick-prev' 
      onClick={onClick}
      aria-label="Previous slide"
      style={{display: isMobile ? 'none' : 'block'}}
    />
  );
};

const NextArrow = (props) => {
  const { onClick, isMobile } = props;
  return (
    <button 
      className='slick-next' 
      onClick={onClick}
      aria-label="Next slide"
      style={{display: isMobile ? 'none' : 'block'}}
    />
  );
};
// const colorizeText = (text, colorForTenthWord) => {
//   if (!text) return null;
  
//   const words = text.split(' ');
//   return words.map((word, index) => {
//     if (index === 4) { // 10th word (index 9)
//       return (
//         <span 
//           key={index} 
//           style={{ color: colorForTenthWord }}
//         >
//           {word}{' '}
//         </span>
//       );
//     }
//     return <span key={index}>{word}{' '}</span>;
//   });
// };

// const calculateTitleHeight = (text, fontSize, containerWidth) => {
//   const tempDiv = document.createElement('div');
//   tempDiv.style.cssText = `
//     position: absolute;
//     visibility: hidden;
//     height: auto;
//     width: ${containerWidth}px;
//     font-size: ${fontSize}px;
//     line-height: 0.9;
//     font-weight: 800;
//     padding: 0 20px;
//   `;
//   tempDiv.innerText = text || '';
//   document.body.appendChild(tempDiv);
//   const height = tempDiv.offsetHeight;
//   document.body.removeChild(tempDiv);
//   return height;
// };

const DynamicTitle = ({ text, thirdColor, isFirstSlide = false, idx, length, paragraphFont }) => {
  const [fontSize, setFontSize] = useState(isFirstSlide ? 48 : 32); // Smaller default for non-first slidess
  const titleRef = useRef(null);
  const containerRef = useRef(null);
  

  useEffect(() => {
    if (!titleRef.current || !containerRef.current || !text) return;

    const container = containerRef.current;
    const title = titleRef.current;
    const containerWidth = container.offsetWidth;
    const minHeight = 240; // 15rem
    const maxHeight = 272; // 17rem
    const minFontSize = 24; // 3rem

    let currentFontSize = idx === 0||idx === length-1 ? 48 : 32; // Start with 4rem
    // let currentHeight = calculateTitleHeight(text, currentFontSize, containerWidth);

    // // If text is too big, decrease font size
    // while (currentHeight > maxHeight && currentFontSize > minFontSize) {
    //   currentFontSize -= 2;
    //   currentHeight = calculateTitleHeight(text, currentFontSize, containerWidth);
    // }

    // If text is too small, increase container height to match content
    // if (currentHeight < minHeight) {
    //   container.style.height = `${currentHeight}px`;
    // }
    const adjustFontSize = () => {
      title.style.fontSize = `${currentFontSize}px`;
      while (title.scrollWidth > container.clientWidth && currentFontSize > minFontSize) {
        currentFontSize -= 2;
        title.style.fontSize = `${currentFontSize}px`;
      }
      //setFontSize(currentFontSize);
      setFontSize(prevSize => (prevSize !== currentFontSize ? currentFontSize : prevSize));

    };

    adjustFontSize();
    //setFontSize(currentFontSize);
  }, [text, idx, length]);

  // Colorize the 9th word (0-based index)
  // const colorizedText = (text, thirdColor) => text?.split(' ').map((word, index) => (
  //   // text inside <c> and </c> tag will be colored
  //   <span 
  //     key={index}
  //     style={{ color: index === 1 ? thirdColor : 'inherit' }}
  //   >
  //     {word}{' '}
  //   </span>

  // ));
  const colorizedText = (text, thirdColor) => {
    // Split the text by <c> and </c> tags
    const parts = text?.split(/<c>|<\/c>/);
    
    return parts?.map((part, index) => (
      <span 
        key={index}
        // Color the text if it's between <c> and </c> (odd indices)
        style={{ color: index % 2 === 1 ? thirdColor : 'inherit' }}
      >
        {part}
      </span>
    ));
  };
  return (
    <div 
      ref={containerRef}
      className='title'
      style={{
       // border: '1px solid blue',
       // minHeight: isFirstSlide ? '15rem' : 'auto',
       // maxHeight: isFirstSlide ? '17rem' : 'auto',
        height: 'auto',
        padding: '0px 20px',
        overflow: 'hidden',
        transition: 'height 0.3s ease',
        WebkitFontSmoothing: 'antialiased',
        fontFamily: paragraphFont,
        // MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility'
      }}
    >
      <p 
        ref={titleRef}
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: idx === 0||idx === length-1 ? '1' : '1.2',
          fontWeight: idx === 0||idx === length-1 ? '800' : '700',
          overflowWrap: 'break-word',
          wordWrap: 'break-word',
          hyphens: 'auto',

         // transition: 'font-size 0.3s ease',
         // WebkitFontSmoothing: 'antialiased',
        //  MozOsxFontSmoothing: 'grayscale',
         // textRendering: 'optimizeLegibility'
        }}
      >
        {colorizedText(text, thirdColor)}
      </p>
    </div>
  );
};

const ProfileSection = ({ slideDatas, currentColorPalletes, onImageUpload }) => {
 // console.log('slideDatas', slideDatas);
//  console.log('currentColorPalletes', currentColorPalletes);
//  console.log('onImageUpload', onImageUpload);
  const handleClick = (e) => {
    e.preventDefault();
   // e.stopPropagation();

  };

  const fileInputRef = useRef(null);

  const handleLabelClick = (e) => {
    e.preventDefault();
    //e.stopPropagation();
    // Programmatically click the hidden file input
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    //e.stopPropagation();
    if (e.target.files && e.target.files[0]) {
      onImageUpload(e);
    }
  };

  return (
    <div className="absolute bottom-6 left-6 flex items-center">
      {/* Image Upload Circle */}
      <div className="relative group" onClick={(e)=>handleClick(e)}>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden cursor-pointer"

          id="profile-upload"
        />
        <div
          role="button"
          className="block w-16 h-16 rounded-full border-2 border-dashed cursor-pointer transition-all group-hover:border-purple-400"
          style={{ borderColor: currentColorPalletes.third_color, backgroundColor: 'white',padding: '1px' }}
          onClick={handleLabelClick}
        >
          {slideDatas?.profileImage ? (
            <img
              src={slideDatas?.profileImage}
              alt="Profile"
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <div className="w-full h-full rounded-full bg-gray-100 flex items-center justify-center">
              <svg className="w-6 h-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
          )}
        </div>
      </div>

      {/* Name and Designation */}
      <div className="ml-4" style={{ color: currentColorPalletes.second_color }}>
        <div className="text-sm font-medium">
          {slideDatas?.name || 'Alexa'}
        </div>
        <div className="text-xs opacity-80">
          {slideDatas?.designation || 'Founder at CarouselPost.in'}
        </div>
      </div>
    </div>
  );
};

const SwipeIndicator = ({ currentColorPalletes }) => (
  <div 
    className="absolute bottom-6 right-6 px-6 py-2 rounded-full flex items-center"
    style={{ 
      backgroundColor: `${currentColorPalletes.third_color}20`,
      border: `1px solid ${currentColorPalletes.third_color}40`
    }}
  >
    <span 
      className="text-sm font-medium"
      style={{ color: currentColorPalletes.third_color }}
    >
      swipe
    </span>
    <svg 
      className="w-4 h-4 ml-2" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke={currentColorPalletes.third_color}
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </div>
);

const CallToAction = ({ text, currentColorPalletes }) => (
  <div className="absolute bottom-32 left-1/2 transform -translate-x-1/2">
    <div 
      className="px-8 py-3 rounded-full flex items-center"
      style={{ 
        backgroundColor: `${currentColorPalletes.third_color}20`,
        border: `1px solid ${currentColorPalletes.third_color}40`
      }}
    >
      <span 
        className="text-sm font-medium"
        style={{ color: currentColorPalletes.third_color }}
      >
        {text || 'Visit us at CarouselPost.in'}
      </span>
    </div>
  </div>
);
const generateRandomNumber = () => {
  return Math.floor(Math.random() * 1000);
}
const generateFaintBackgroundImage = (setFaintBackgroundImageUrl, dispatch, loading, setLoading) => {
  setLoading(true);
  const url = `https://picsum.photos/seed/${generateRandomNumber()}/2400/2400`;
  setFaintBackgroundImageUrl(url);
  dispatch(changeFaintBackgroundImageUrl(url));
  setTimeout(() => {
    setLoading(false);
  }, 3100);
}
const SettingsBox = ({ 
  index, 
  slideData, 
  focusedTextarea, 
  setFocusedTextarea, 
  handleChange,
  showHeadshot,
  setShowHeadshot,
  showLastSlideProfile,
  setShowLastSlideProfile,
  showCTA,
  setShowCTA,
  showSwipe,
  setShowSwipe,
  showImages,
  setShowImages,
  onImageUpload,
  totalSlides,
  imageUrls,
  setImageUrls,
  handleImageReload,
  mid_section_format,
  setMidSectionFormat,
  mid_section_image,
  setMidSectionImage,
  handleMidSectionImageUpload,
  showFaintBackgroundImages,
  setShowFaintBackgroundImages,
  faintBackgroundImageUrl,
  setFaintBackgroundImageUrl,
  dispatch,
  loading,
  setLoading
}) => (
  <div className="settings-box" style={{
    width: '100%',
    maxWidth: '400px',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginTop: '20px',
    fontSize: '13px' // Smaller base font size
  }}>
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-sm font-semibold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
        Slide {index + 1} Content
      </h3>
      <div className="px-2 py-0.5 rounded-full bg-purple-100 text-purple-600 text-xs font-medium">
        Editing
      </div>
    </div>

    <div className="space-y-3">
      {/* Profile section toggles and fields */}
      {(index === 0 || index === totalSlides - 1) && (
        <div className="p-3 bg-gray-50 rounded-lg mb-2">
          <h4 className="text-xs text-gray-700 mb-2">Profile Section</h4>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs text-gray-600">Show Profile</span>
            <Switch
              size="small"
              checked={index === 0 ? showHeadshot : showLastSlideProfile}
              onChange={(checked) => {
                if (index === 0) {
                  setShowHeadshot(checked);
                } else {
                  setShowLastSlideProfile(checked);
                }
              }}
            />
          </div>

          {/* Profile fields - only show for first slide when enabled */}
          {(index === 0 && showHeadshot) && (
            <>
              {/* Name Input */}
              <div className="mb-2">
                <label className="block text-xs text-gray-600 mb-1">Name</label>
                <Input
                  size="small"
                  placeholder="Enter name"
                  className="w-full rounded-md text-xs"
                  value={slideData[index]?.name}
                  onChange={(e) => handleChange(e, index, 'name')}
                  style={{ fontSize: '11px' }}
                />
              </div>

              {/* Designation Input */}
              <div className="mb-2">
                <label className="block text-xs text-gray-600 mb-1">Designation</label>
                <Input
                  size="small"
                  placeholder="Enter designation"
                  className="w-full rounded-md text-xs"
                  value={slideData[index]?.designation}
                  onChange={(e) => handleChange(e, index, 'designation')}
                  style={{ fontSize: '11px' }}
                />
              </div>

              {/* Profile Image Upload */}
              <div>
                <label className="block text-xs text-gray-600 mb-1">Profile Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={onImageUpload}
                  
                  className="block w-full text-xs text-gray-500
                    file:mr-4 file:py-2 file:px-4
                    file:rounded-full file:border-0
                    file:text-xs file:font-semibold
                    file:bg-purple-50 file:text-purple-600
                    hover:file:bg-purple-100"
                />
              </div>
            </>
          )}
        </div>
      )}
      
      {
        index === 0 && (
          <div className="p-3 bg-gray-50 rounded-lg mb-2 flex items-center justify-between">
          <div className="p-3 bg-gray-50 rounded-lg mb-2 ">
            <h4 className="text-xs text-gray-700 mb-2">Templete Edit Section</h4>
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs text-gray-600">Show Faint Background Images</span>
            </div>
            <Switch
              size="small"
              checked={showFaintBackgroundImages}
              onChange={(checked) => {
                setShowFaintBackgroundImages(checked);
                if (checked) {
                  dispatch(changeShowFaintBackgroundImages(checked));
                }
              }}
            />
          </div>
          <div className="p-3 bg-gray-50 rounded-lg mb-2">
            {loading ? <Spin indicator={<LoadingOutlined spin />} /> : <ReloadOutlined  onClick={() => generateFaintBackgroundImage(setFaintBackgroundImageUrl, dispatch, loading, setLoading)} style={{cursor: 'pointer', visibility: showFaintBackgroundImages ? 'visible' : 'hidden'}}  />}
          </div>
          </div>
        )
      }

      {(index !==0 && index !== totalSlides - 1) && (
        <>
         <div className="p-3 bg-gray-50 rounded-lg mb-2">
         <h4 className="text-xs text-gray-700 mb-2">Templete Edit Section</h4>
         <div className="flex items-center justify-between mb-3">
          <span className="text-xs text-gray-600">Show Images</span>
          <div className="flex flex-row gap-2">
          <Switch
            size="small"
            checked={showImages[index]}
            onChange={(checked) => setShowImages(prev => ({ ...prev, [index]: checked }))}
          />
          {loading ? <Spin indicator={<LoadingOutlined spin />} /> : <ReloadOutlined onClick={() => handleImageReload(index, loading, setLoading) } style={{cursor: 'pointer', visibility: showImages[index] ? 'visible' : 'hidden'}}  />}
          {/* <ReloadOutlined onClick={() => handleImageReload(index, loading, setLoading) } style={{cursor: 'pointer', visibility: showImages[index] ? 'visible' : 'hidden'}}  /> */}
          </div>
         </div>
        {showImages[index] && (<div className="p-3 bg-gray-50 rounded-lg mb-2 flex items-center space-x-2">
            <span className="text-gray-600 text-sm">🖼️ Format:</span>
            <Radio.Group
              value={mid_section_format}
              size="small"
              onChange={(e) => setMidSectionFormat(prev => ({...prev, [index]: e.target.value}))}
            >
              <Radio.Button style={{ fontSize: "10px" }} value="text-image">
                📝 + 🖼️ Text + Image
              </Radio.Button>
              <Radio.Button style={{ fontSize: "10px" }} value="image">
                🖼️ Image Only
              </Radio.Button>
            </Radio.Group>

                
                
          </div>)}
      {showImages[index] && (<div>
                <span className="text-gray-600 text-sm">🖼️ Upload Image:</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleMidSectionImageUpload(e,index)}
                  
                  className="block w-full text-xs text-gray-500
                    file:mr-4 file:py-2 file:px-4
                    file:rounded-full file:border-0
                    file:text-xs file:font-semibold
                    file:bg-purple-50 file:text-purple-600
                    hover:file:bg-purple-100"
                />
            </div>)}

         </div>
         
         
        </>
      )}

      {/* Title section with accent button */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="block text-xs font-medium text-gray-700">
            Title
          </label>
          <Tooltip title="Add colored text">
            <Button 
              size="small"
              type="text"
              icon={<BgColorsOutlined />}
              className="text-xs text-purple-600 hover:bg-purple-50"
              onClick={() => {
                const currentValue = slideData[index]?.title || '';
                handleChange(
                  { target: { value: currentValue + '<c></c>' } },
                  index,
                  'title'
                );
              }}
            >
              Add Accent
            </Button>
          </Tooltip>
        </div>
        <TextArea
          size="small"
          placeholder="Enter your main title..."
          className="w-full rounded-md text-sm"
          autoSize={{ minRows: 3, maxRows: 4 }}
          value={slideData[index]?.title}
          onChange={(e) => handleChange(e, index, 'title')}
          onClick={() => setFocusedTextarea(index)}
          style={{
            backgroundColor: focusedTextarea === index ? '#faf5ff' : 'white',
            transition: 'all 0.3s ease'
          }}
        />
      </div>

      {/* Description section with formatting toolbar */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="block text-xs font-medium text-gray-700">
            Description
          </label>
          <div className="flex gap-1">
            <Tooltip title="Add bullet list">
              <Button 
                size="small"
                type="text"
                icon={<UnorderedListOutlined />}
                className="text-xs text-purple-600 hover:bg-purple-50"
                onClick={() => {
                  const currentValue = slideData[index]?.paragraph || '';
                  handleChange(
                    { target: { value: currentValue + '<ul><li></li></ul>' } },
                    index,
                    'paragraph'
                  );
                }}
              />
            </Tooltip>
            <Tooltip title="Add numbered list">
              <Button 
                size="small"
                type="text"
                icon={<OrderedListOutlined />}
                className="text-xs text-purple-600 hover:bg-purple-50"
                onClick={() => {
                  const currentValue = slideData[index]?.paragraph || '';
                  handleChange(
                    { target: { value: currentValue + '<ol><li></li></ol>' } },
                    index,
                    'paragraph'
                  );
                }}
              />
            </Tooltip>
            <Tooltip title="Add space between lines">
              <Button 
                size="small"
                type="text"
                icon={<SplitCellsOutlined />}
                className="text-xs text-purple-600 hover:bg-purple-50"
                onClick={() => {
                  const currentValue = slideData[index]?.paragraph || '';
                  handleChange(
                    { target: { value: currentValue + '<br/>' } },
                    index,
                    'paragraph'
                  );
                }}
              />
            </Tooltip>
            <Tooltip title="Add bold text">
              <Button 
                size="small"
                type="text"
                icon={<BoldOutlined />}
                className="text-xs text-purple-600 hover:bg-purple-50"
                onClick={() => {
                  const currentValue = slideData[index]?.paragraph || '';
                  handleChange(
                    { target: { value: currentValue + '<strong></strong>' } },
                    index,
                    'paragraph'
                  );
                }}
              />
            </Tooltip>
          </div>
        </div>
        <TextArea
          size="small"
          placeholder="Enter your detailed content..."
          className="w-full rounded-md text-sm"
          autoSize={{ minRows: 3, maxRows: 4 }}
          value={slideData[index]?.paragraph}
          onChange={(e) => handleChange(e, index, 'paragraph')}
          onClick={() => setFocusedTextarea(index)}
          style={{
            backgroundColor: focusedTextarea === index ? '#faf5ff' : 'white',
            transition: 'all 0.3s ease'
          }}
        />
      </div>

      {/* Character count indicators - adjust based on slide index */}
      <div className="flex justify-between text-xs text-gray-400 mt-1">
        <span>
          Title: {slideData[index]?.title?.length || 0}/200
        </span>
        <span>
          Description: {slideData[index]?.paragraph?.length || 0}/500
        </span>
      </div>

      {/* CTA Section for last slide */}
      {index === totalSlides - 1 && (
        <div className="p-3 bg-gray-50 rounded-lg mb-2">
          <h4 className="text-xs text-gray-700 mb-2">Call to Action</h4>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-gray-600">Show CTA Button</span>
            <Switch
              size="small"
              checked={showCTA}
              onChange={setShowCTA}
            />
          </div>
          {showCTA && (
            <div>
              <label className="block text-xs text-gray-600 mb-1">CTA Text</label>
              <Input
                size="small"
                placeholder="Visit us at CarouselPost.in"
                className="w-full rounded-md text-xs"
                value={slideData[index]?.ctaText}
                onChange={(e) => handleChange(e, index, 'ctaText')}
                style={{ fontSize: '11px' }}
              />
            </div>
          )}
        </div>
      )}

      {/* Add tagline for first and last slide */}
      {(index === 0 || index === totalSlides - 1) && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Tagline
          </label>
          <TextArea
            size="small"
            placeholder="Enter a catchy tagline..."
            className="w-full rounded-md text-sm"
            autoSize={{ minRows: 2, maxRows: 3 }}
            value={slideData[index]?.tagline}
            onChange={(e) => handleChange(e, index, 'tagline')}
            onClick={() => setFocusedTextarea(index)}
            style={{
              backgroundColor: focusedTextarea === index ? '#faf5ff' : 'white',
              transition: 'all 0.3s ease'
            }}
          />
        </div>
      )}
    </div>
  </div>
);

const SlideScreen = ({isMobile, userData}) => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [total_slides, setTotalSlides] = useState(5);
  const [slideData, setSlideData] = useState([]);
  const [showImages, setShowImages] = useState([false,false,false,false,false]);
  const [imageUrls, setImageUrls] = useState([{url: '',name:'', idx: 0},{url: '',name:'', idx: 1},{url: '',name:'', idx: 2},{url: '',name:'', idx: 3},{url: '',name:'', idx: 4}]);
  const [focusedTextarea, setFocusedTextarea] = useState(null); // State to keep track of the focused textarea
  // const textAreaRefs = useRef([null, null, null]); // Ref for the TextAreas
  const [faintBackgroundImageUrl, setFaintBackgroundImageUrl] = useState('');
  const [showFaintBackgroundImages, setShowFaintBackgroundImages] = useState(false);
  const [position, setPosition] = useState([{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 }]);
  const [dragging, setDragging] = useState([false,false,false,false,false]);
  const [offset, setOffset] = useState([{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 },{ x: 0, y: 0 }]);
  const [mid_section_format, setMidSectionFormat] = useState(['text-image','text-image','text-image','text-image','text-image']);
  //const [mid_section_image, setMidSectionImage] = useState([{url: '', idx: 0},{url: '', idx: 1},{url: '', idx: 2},{url: '', idx: 3},{url: '', idx: 4}]);
  // const handleMouseDown = (e, index) => {
  //   setDragging(prev => [...prev.map((dragging, i) => i === index ? true : dragging)]);
  //   setOffset(prev => [...prev.map((offset, i) => i === index ? { x: e.clientX - position[i].x, y: e.clientY - position[i].y } : offset)]);
  // };

  // const handleMouseMove = (e, index) => {
  //   if (!dragging[index]) return;
  //   setPosition(prev => [...prev.map((position, i) => i === index ? { x: e.clientX - offset[i].x, y: e.clientY - offset[i].y } : position)]);
  // };
   const dispatch = useDispatch();

  // const handleMouseUp = (index) => {
  //   setDragging(prev => [...prev.map((dragging, i) => i === index ? false : dragging)]);
  // };

  const handleMouseDown = useCallback((e, index) => {
    setDragging(prev => {
        const newDragging = [...prev];
        newDragging[index] = true;
        return newDragging;
    });
    setOffset(prev => {
        const newOffset = [...prev];
        newOffset[index] = { 
            x: e.clientX - position[index].x, 
            y: e.clientY - position[index].y 
        };
        return newOffset;
    });
}, [position]);

const handleMouseMove = useCallback((e, index) => {
    if (!dragging[index]) return;
    setPosition(prev => {
        const newPosition = [...prev];
        newPosition[index] = { 
            x: e.clientX - offset[index].x, 
            y: e.clientY - offset[index].y 
        };
        return newPosition;
    });
}, [dragging, offset]);

const handleMouseUp = useCallback((index) => {
    setDragging(prev => {
        const newDragging = [...prev];
        newDragging[index] = false;
        return newDragging;
    });
}, []);
  const SlideCount = useSelector((state) => state.counter.slideCount);
  
 
  const slidess = Array.from({ length: total_slides }, (v, i) => i + 1);


  const { slideCount, template, fontStyles, backgroundDesign, currentColorPalletes, slides, alignment, fontSize,fontWeight} = useSelector(
    (state) => state.counter,
  );
  console.log('state:',slides, template, slideCount);

  const [taglineFont, paragraphFont] = fontStyles.split(" + ");
  useEffect(() => {
    const loadFont = (font) => {
      const link = document.createElement("link");
      link.href = `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, "+")}:wght@400;700&display=swap`;
      link.rel = "stylesheet";
      document.head.appendChild(link);
      return () => document.head.removeChild(link); // Cleanup
    };

    loadFont(taglineFont);
    loadFont(paragraphFont);
  }, [taglineFont, paragraphFont]);
useEffect(()=>{
    setSlideData([...slides])
    console.log('=========================================================:',slides);
},[slides])
useEffect(()=>{
  console.log('SlideCount:',SlideCount);
  setShowImages(Array(SlideCount).fill(false))
  setMidSectionFormat(Array.from({ length: SlideCount }, () => 'text-image'))
  setImageUrls(Array.from({ length: SlideCount }, (_, i) => ({ url: '', name: '', idx: i })));
  setPosition(Array.from({ length: SlideCount }, () => ({ x: 0, y: 0 })));
  setOffset(Array.from({ length: SlideCount }, () => ({ x: 0, y: 0 })));
  setDragging(Array(SlideCount).fill(false));
},[SlideCount])
 // console.log('template from slidesesssssssss:',template);
  const handleSlideData = () => {
    let arr = [];
    for(let i = 0; i < SlideCount; i++){
      arr.push({
        idx: i,
        tagline: '',
        title: '',
        paragraph: '',
        name: i === 0 ? 'Alexa' : '', // Default name for first slide
        designation: i === 0 ? 'Founder at CarouselPost.in' : '', // Default designation for first slide
        profileImage: '', // Add profile image field
        ctaText: i === SlideCount - 1 ? 'Visit us at http://www.CarouselPost.in' : '' // Default CTA text for last slide
      });
    }
    setSlideData(arr);
  };

  useEffect(() => {
   // const slidess = selectors.getSlideCount();
   // console.log('slidess', SlideCount);
   // console.log('d',selectors.getCounter())
   setTotalSlides(SlideCount)
  // handleSlideData()
  },[SlideCount]);
  
  const getImageUrl = (idx) => {
    if(imageUrls[idx]?.url){
      return imageUrls[idx]?.url;
    }else{
      const url = `https://picsum.photos/seed/${generateRandomNumber()*idx}/1000/2400`;
      setImageUrls(prev => ({...prev, [idx]: {url, idx}}));
      return url;
    }
  };

  const handleImageReload = (idx, loading, setLoading) => {
    setLoading(true);
    const url = `https://picsum.photos/seed/${generateRandomNumber()*idx}/1000/2400`;
    setImageUrls(prev => ({...prev, [idx]: {url, idx}}));
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }

 
 
  useEffect(() => {
    // Do something when currentColorPalletes changes
   // console.log('currentColorPalletes changed---:', currentColorPalletes);
    
  }, [currentColorPalletes]); // Add currentColorPalletes to the dependency array

  const handleSlideClick = (index,e) => {
    e.stopPropagation();
    setCurrentSlide(index);
   // Set the focused textarea index
   // setFocusedTextarea(index);
    // Focus on the clicked textarea
    // if (textAreaRefs.current[index]) {
    //   textAreaRefs.current[index].focus();
    // }
    
  };

  const handlePrev = () => {
    setCurrentSlide(currentSlide - 1);
    let id = currentSlide;
    handleSlide(id);
    // Other logic related to the prev button
  };

  const handleNext = () => {
    setCurrentSlide(currentSlide + 1);
    let id = currentSlide;
    handleSlide(id);
    // Other logic related to the next button
  };

  const handleSlide = (id) =>{
    slide(id);
  }
  const settings = {
    
    className: 'center',
    variableWidth: isMobile ? false : true,
    centerMode: isMobile ? false : true,
    infinite: false,
    //centerPadding: '333px',
    slidesToShow: 1,
    speed: 500,

    width: '80%',
    draggable: true,
    accessibility: true,
    focusOnSelect:true,
    afterChange: setCurrentSlide,
    prevArrow:  <PrevArrow onClick={handlePrev} isMobile={isMobile} />,
    nextArrow:  <NextArrow onClick={handleNext} isMobile={isMobile}/>,
    
  };
  const BoldText = ({ text }) => <span style={{ fontWeight: 'bold' }}>{text}</span>;
  const formatText = (text) => {
    // Split text into words
    const words = text.split(' ');

    // Map each word to determine if it should be bold
    return words.map((word, index) => {
      // You can implement your own logic to determine which words should be bold
      // For example, you might check for specific keywords or conditions
      if (word === 'bold') {
        return <BoldText key={index} text={word} />;
      } else {
        return word + ' ';
      }
    });
  };
  const generateRandomNumber = () => {
    return Math.floor(Math.random() * 1000);
  }
  const handleChange = (e, index, type) => {
    const value = e?.target?.value ?? '';
    setSlideData(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        [type]: value
      };
      return newData;
    });
  };
  const [showHeadshot, setShowHeadshot] = useState(true);
  const [showSwipe, setShowSwipe] = useState(true);
  const [showLastSlideProfile, setShowLastSlideProfile] = useState(true);
  const [showCTA, setShowCTA] = useState(true);
  const [loading, setLoading] = useState(false);
  const settingsBox = (index) => (
    <SettingsBox
      index={index}
      slideData={slideData}
      focusedTextarea={focusedTextarea}
      setFocusedTextarea={setFocusedTextarea}
      handleChange={handleChange}
      showHeadshot={showHeadshot}
      setShowHeadshot={setShowHeadshot}
      showLastSlideProfile={showLastSlideProfile}
      setShowLastSlideProfile={setShowLastSlideProfile}
      showCTA={showCTA}
      setShowCTA={setShowCTA}
      showSwipe={showSwipe}
      setShowSwipe={setShowSwipe}
      onImageUpload={handleImageUpload}
      totalSlides={total_slides}
      showImages={showImages}
      setShowImages={setShowImages}
      imageUrls={imageUrls}
      setImageUrls={setImageUrls}
      handleImageReload={handleImageReload}
      mid_section_format={mid_section_format}
      setMidSectionFormat={setMidSectionFormat}
      showFaintBackgroundImages={showFaintBackgroundImages}
      setShowFaintBackgroundImages={setShowFaintBackgroundImages}
    //  mid_section_image={mid_section_image}
     // setMidSectionImage={setMidSectionImage}
      handleMidSectionImageUpload={handleMidSectionImageUpload}
      faintBackgroundImageUrl={faintBackgroundImageUrl}
      setFaintBackgroundImageUrl={setFaintBackgroundImageUrl}
      dispatch={dispatch}
      loading={loading}
      setLoading={setLoading}
    />
  ); 
  
  

  const slide = (idx) => (
    <div style={{margin: '0px'}} className='super-exterior' key={idx}>
       
      <div className='bgra relative' style={{
        width: `${template.width}rem`,
        height: `${template.height}rem`,
        border: '1px dotted grey',
        color: currentColorPalletes.second_color,
        overflow: 'hidden',
        backgroundColor: currentColorPalletes.first_color,
        position: 'relative',
        // paddingTop: (idx === 0 || idx === slidess.length - 1) ? '5rem' : '2rem',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        backgroundImage: idx === 0 && showFaintBackgroundImages ? `url("${faintBackgroundImageUrl}")` : 'none',
        backgroundSize: idx === 0 && showFaintBackgroundImages ? 'cover' : 'none',
        backgroundPosition: idx === 0 && showFaintBackgroundImages ? 'center' : 'none',
        backgroundRepeat: idx === 0 && showFaintBackgroundImages ? 'no-repeat' : 'none',
        backgroundBlendMode: idx === 0 && showFaintBackgroundImages ? 'multiply' : 'none',
      }}>
          
          <div style={{
            paddingTop: (idx === 0 || idx === slidess.length - 1) ? '2rem' : '2rem',
          }}></div>
        {/* Pattern Overlay */}
        {template.patternUrl && (
          <div 
            className="absolute inset-0 pattern_layer"
            style={{
              backgroundImage: `url("${template?.patternUrl}")`,
              backgroundRepeat: 'repeat',
              opacity: 0.2,
              // backgroundColor: 'transparent',
              maskImage: `url("${template?.patternUrl}")`,
              WebkitMaskImage: `url("${template?.patternUrl}")`,
              backgroundColor: currentColorPalletes.third_color,
            }}
          />
        )}
        
        {/* Content */}
        <div className="relative z-10" style={{
          height: ( idx === slidess.length - 1) ? '70%' : '85%',
          display: 'flex',
         //alignItems: alignment === 'center-alignment'?'center':'flex-start',
         textAlign: alignment === 'center-alignment'?'center':'left',
          // border: '1px solid blue',
          color: currentColorPalletes.second_color,
          overflow: 'hidden',
          // WebkitPrintColorAdjust: 'exact',
          // colorAdjust: 'exact',
        }}>
          {/* First and Last slide content */}
          {(idx === 0 || idx === slidess.length - 1) ? (
            <div style={{display: 'flex', flexDirection: 'column',wordBreak:'break-word'
              }}>
              <div className='tagline' style={{
                fontSize: '0.8rem',
                margin: '10px 20px',
                maxHeight: '35rem',
                fontFamily: taglineFont,
               
                // border: '1px solid red',
                overflow: 'hidden',
                alignItems: alignment === 'center-alignment'?'center':'flex-start',
                color: currentColorPalletes.second_color
              }}>
                <p style={{ wordBreak:'break-word' }}>
                  {slideData[idx]?.tagline}
                </p>
              </div>

              <div style={{gap: '1rem'}}>
                <DynamicTitle 
                  text={slideData[idx]?.title}
                  thirdColor={currentColorPalletes.third_color}
                  isFirstSlide={true}
                  idx={idx}
                  length={slidess.length}
                  paragraphFont={paragraphFont}
                  // style={{
                  //   WebkitFontSmoothing: 'antialiased',
                  //   MozOsxFontSmoothing: 'grayscale',
                  //   textRendering: 'optimizeLegibility'
                  // }}
                />
                <div className='paragraph' style={{
                  //maxHeight: '12rem',
                  lineHeight: '1.2',
                  fontSize: '1rem',
                  padding: '0px 20px',
                  overflow: 'hidden',
                  marginTop: '1rem',
                  fontFamily: taglineFont,
                  // WebkitFontSmoothing: 'antialiased',
                  // MozOsxFontSmoothing: 'grayscale',
                  // textRendering: 'optimizeLegibility'
                }}>
                  <div  style={{ overflowWrap: 'break-word', wordWrap: 'break-word', color: currentColorPalletes.second_color } } dangerouslySetInnerHTML={{ __html: slideData[idx]?.paragraph }} />
                    {/* {slideData[idx]?.paragraph} */}
                  
                </div>
              </div>
            </div>
          ) : (
            // Other slidess content - grows from top
        <div style={{display: 'flex', flexDirection: 'row',justifyContent: 'space-between',width: '100%'}}>
          
        <div style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              width: showImages[idx] && mid_section_format[idx] === 'text-image' ? '60%' : !showImages[idx] ? '100%' : '0%',
              padding: showImages[idx] && mid_section_format[idx] === 'text-image' ? '10px 20px' : !showImages[idx] ? '10px 20px' : '',
              //visibility: showImages[idx] && mid_section_format[idx] === 'image' ?  'hidden' : 'visible',
              gap: '1rem'
            }}>
              {((mid_section_format[idx] === 'text-image' && showImages[idx]) || (!showImages[idx])) && (<><DynamicTitle 
                text={slideData[idx]?.title}
                thirdColor={currentColorPalletes.third_color}
                isFirstSlide={false}
                idx={idx}
                length={slidess.length}
                paragraphFont={paragraphFont}
              />
                <div className='paragraph' style={{
                        flex: 1,
                        minHeight: 0,
                        fontSize: '1rem',
                        lineHeight: '1.2',
                        overflow: 'hidden',
                        marginTop: '1rem',
                        fontFamily: taglineFont,
                        height: 'auto',
                        //textAlign: 'center'
                      }}>
                        <div style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: slideData[idx]?.paragraph }} />
                         
                </div></>)}
        </div>

        {showImages[idx] && (<div style={{width: mid_section_format[idx] === 'text-image' ? '40%' : '100%', right: '0',
          // border: '1px solid green', 
           zIndex: '1000',overflow:'hidden'}}>
          {/* <img src={`https://picsum.photos/100/600?random=${idx}`} style={{width: '100%', height: '100%'}} alt="Profile" /> */}
          {/* <DraggableImage idx={idx} /> */}
          <div
          id={`draggable-image-${idx}`}
      onMouseDown={(e) => handleMouseDown(e, idx)}
      onMouseMove={(e) => handleMouseMove(e, idx)}
      onMouseUp={(e) => handleMouseUp(idx)}
      style={{
        position: "relative",
        left: `${position[idx].x}px`,
        top: `${position[idx].y}px`,
        width: "100%",
        // border: "1px solid green",
        cursor: "grab",
      }}
    >
      <img
        src={getImageUrl(idx)}
        style={{ width: "100%", height: "100%" ,objectFit: 'cover',aspectRatio: mid_section_format[idx] === 'text-image' ?'1/2.4':'1/1'}}
        alt={`Profile-${idx}`}
      />
    </div>
        </div>)}

        </div>
          )}
        </div>

        {/* Profile Section for first slide */}
        {(idx === 0 && showHeadshot) && (
          <ProfileSection 
            slideDatas={slideData[idx]} 
            currentColorPalletes={currentColorPalletes}
            onImageUpload={handleImageUpload}
          />
        )}

        {/* Profile Section for last slide - uses first slide's profile data */}
        {(idx === slidess.length - 1 && showLastSlideProfile) && (
          <ProfileSection 
            slideDatas={{
              ...slideData[idx],
              name: slideData[0]?.name, // Use first slide's name
              designation: slideData[0]?.designation, // Use first slide's designation
              profileImage: slideData[0]?.profileImage // Use first slide's profile image
            }}
            currentColorPalletes={currentColorPalletes}
            onImageUpload={null} // Disable image upload for last slide
          />
        )}

        {/* CTA button for last slide with toggle */}
        {idx === slidess.length - 1 && showCTA && (
          <CallToAction 
            text={slideData[idx]?.ctaText}
            currentColorPalletes={currentColorPalletes}
          />
        )}

        {/* Swipe Indicator only for first slide */}
        {idx === 0 && showSwipe && (
          <SwipeIndicator currentColorPalletes={currentColorPalletes} />
        )}

{userData?.subscription === false && (<div style={{backgroundColor: 'black',width: '100%',height: 'auto',bottom: '0',position: 'absolute'}}>
            <p style={{color: 'white',fontSize: '0.7rem',textAlign: 'center'}}>Made with love @CarouselPost</p>
          </div>)}
      </div>
      
      {currentSlide === idx ? settingsBox(idx) : <></>}
      
    </div>
  );
  
  

  // Add image upload handler
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageUrl = reader.result;
        setSlideData(prevData => {
          const newData = [...prevData];
          newData[0] = {
            ...newData[0],
            profileImage: imageUrl
          };
          return newData;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleMidSectionImageUpload = (e,idx) => {
    // if(imageUrls[idx]?.url){
    //   return imageUrls[idx]?.url;
    // }else{
    //   const url = `https://picsum.photos/seed/${generateRandomNumber()*idx}/1000/2400`;
    //   setImageUrls(prev => ({...prev, [idx]: {url, idx}}));
    //   return url;
    // }
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageUrl = reader.result;
        setImageUrls(prev => ({...prev, [idx]: {url: imageUrl, name: file.name, idx}}));
        return imageUrl;
      };
      reader.readAsDataURL(file);
      
    }
  };

  return (<div>
  <div style={{marginTop: '50px'}}>
    <Slider {...settings}>
          {slidess.map((e,idx)=>(
            <div key={idx} style={{margin: '0px'}} onClick={(e) => handleSlideClick(idx,e)}>
           {slide(idx)}
           
           </div>
          ))}
        </Slider>

        </div>
  </div>
  )
};

export default SlideScreen;
